<template>
  <div class="search">
    <button class="search-revoke" v-show="isSearchComplete" @click="cancelSearch">
      <span class="fal fa-undo search-revoke__icon"></span>
      검색 취소
    </button>

    <div class="search-bar">
      <label for="search-bar-input-booking" class="blind">검색창</label>
      <input
        id="search-bar-input-booking"
        type="text"
        autocomplete="off"
        maxlength="30"
        placeholder="자원 이름 검색"
        v-model="searchString"
        v-on:keyup.enter="search"
      />

      <button class="search-button" type="button" @click="search" aria-label="검색">
        <i class="fal fa-search" aria-hidden="true"></i>
        <span class="blind">검색</span>
      </button>
    </div>

    <form method="post" ref="searchForm" :action="'/' + domain + '/booking/bookingResource/resourceList/'">
      <input type="hidden" name="booking_search_name" :value="searchString" />
    </form>
  </div>
</template>

<script>
export default {
  name: 'BookingSearchBox',
  data() {
    return {
      searchString: '',
      isSearchComplete: false,
    };
  },
  props: {
    domain: {
      type: String,
    },
  },
  mounted() {
    let self = this;
    document.addEventListener('DOMContentLoaded', () => {
      let bookingSearchName = document.getElementById('booking_search_name_hidden');
      if (bookingSearchName) {
        self.searchString = bookingSearchName.value;
        self.isSearchComplete = true;
      }
    });
  },
  methods: {
    search() {
      this.$refs.searchForm.submit();
    },
    cancelSearch() {
      location.href = '/' + this.domain + '/booking/bookingMain/';
    },
  },
};
</script>
